export default __webpack_public_path__ + "static/media/wildwest.eefd74f3.png";